export default function CardInner({ children }: { children: any }) {
    return (<div className=" rounded-md bg-[#04161e69] p-3">
        {children}
    </div>)
}